<div class="card border-radius-5">
  <div class="relative pt-3">
    <cp-widget-header
      text="Top tip"
      icon="light-bulb"
      variant="light"
      [isAbsolutePosition]="true" />
  </div>

  <div class="py-4">
    <div class="widget-base-layout text-center px-5 pt-2">
      <div class="text-28 bold-800">Get best deals!</div>
      <img class="widget-img m-a my-4" [src]="'two-story-house-gold.png' | brandingAssetPath" />
      <div class="text-14">
        It looks like we don't have any mortgage or property details for you yet. If you have
        either, let us know, so we can start searching for best deals!
      </div>
      <div class="m-a">
        <button pButton class="p-button p-button-primary" [routerLink]="buttonUrl">
          Add your property
        </button>
      </div>
    </div>
  </div>
</div>
